<template>
  <div
    v-for="(zone, index) in zones"
    :key="index"
    class="cell"

    v-bind="{...$attrs,
      ...(zone.prosProductPoolMedia &&
        getDataAttributesFromObj(zone.prosProductPoolMedia, [
          'productId',
          'categoryId',
          'context',
          'maxRecs',
        ])),
    ...(adobeTargetId && {'data-targetIdentifier' : adobeTargetId}) }"
  >
    <template v-if="zone?.visualFilter">
      <VisualFilter
        :visual-filter="zone.visualFilter"
        :ks-meta="ksMeta"
      />
    </template>
    <template v-else-if="zone?.imageMap || zone?.banner">
      <ImageMap
        :image-map="zone.imageMap || zone.banner"
      />
    </template>
    <template v-else-if="zone?.singleImageTextAd">
      <SingleImageTextAdWrapper
        :attributes="zone.singleImageTextAd.attributes"
      >
        <SingleImageTextAd
          :single-image-text-ad="zone.singleImageTextAd"
        />
      </SingleImageTextAdWrapper>
    </template>
    <template v-else-if="zone?.textAd">
      <TextAd
        :text="zone.textAd"
        :top-level-comp="true"
      />
    </template>
    <template v-else-if="zone?.spacer">
      <Spacer
        :spacer="zone.spacer"
      />
    </template>
    <template v-else-if="zone?.visualNavigation">
      <VisualNavigation
        :visual-navigation="zone.visualNavigation"
      />
    </template>
    <template v-else-if="zone?.brandCategoryIcon">
      <BrandCategoryIcons
        :brand-category-icons="zone.brandCategoryIcon"
      />
    </template>
    <template v-else-if="zone?.heroSubAd">
      <HeroSubAd
        :hero-sub-ad="zone.heroSubAd"
      />
    </template>
    <template v-else-if="zone?.subAd">
      <SubAd
        :sub-ad="zone.subAd"
      />
    </template>
    <template v-else-if="zone?.carousel">
      <Carousel
        :carousel="zone.carousel"
        :meta="isPlpPage === 'discovery'? ksMeta : meta"
      />
    </template>
    <template v-else-if="zone?.productPoolMedia">
      <ProductPool
        :product-pool-media="zone.productPoolMedia"
        :meta="meta"
        :is-plp-page="isPlpPage"
        :ks-meta="ksMeta"
      />
    </template>
    <template v-else-if="zone?.prosProductPoolMedia">
      <ProsProductPool
        :pros-product-pool-media="zone.prosProductPoolMedia"
        :properties="meta"
      />
    </template>
    <template v-else-if="zone?.shortTextAd">
      <ShortTextAd
        :short-text-ad="zone.shortTextAd"
      />
    </template>
    <template v-else-if="zone?.subAdFourImages">
      <SubAdFourImages
        :sub-ad-four-images="zone.subAdFourImages"
      />
    </template>
    <template v-else-if="zone?.subAdPool">
      <SubAdPool
        :sub-ad-pool="zone.subAdPool"
      />
    </template>
    <template v-else-if="zone?.header">
      <Header
        :header="zone.header"
      />
    </template>
    <template v-else-if="zone?.placeHolder && zone?.placeHolder?.value.indexOf('GOOGLE_AD') === -1">
      <Placeholder
        :place-holder="zone.placeHolder"
        :loyalty="zone?.loyalty"
      />
    </template>
    <template v-else-if="zone?.salesBanner">
      <SalesBanner
        :sales-banner="zone.salesBanner"
      />
    </template>
    <template v-else-if="zone?.iconGrid">
      <IconGrid
        :icon-grid="zone.iconGrid"
      />
    </template>
    <template v-else-if="zone?.brandShop">
      <BrandShop
        :brand-shop="zone.brandShop"
      />
    </template>
    <template v-else-if="zone?.brandShopLogoBanner">
      <BrandShopLogoBanner
        :brand-shop-logo-banner="zone.brandShopLogoBanner"
      />
    </template>
    <template v-else-if="zone?.siteMonetization">
      <SponsoredItemsMedia
        :meta="meta"
      />
    </template>
    <template v-else-if="zone?.placeHolder && zone?.placeHolder?.value.indexOf('GOOGLE_AD') !== -1">
      <GoogleAdPlaceholderMedia
        :meta="meta"
        :placeholder="zone?.placeHolder"
      />
    </template>
    <template v-else-if="isPlpPage === 'discovery' ? zone?.brandShowCase?.productPoolMedia?.collection?.length >= 4 : zone?.brandShowcase">
      <BrandShowcaseMedia
        :meta="isPlpPage === 'discovery'? ksMeta:meta"
        :sponsored-brand-response="zone?.brandShowCase"
      />
    </template>
    <template v-else-if="zone?.bannerWithIcon">
      <BannerWithIcon
        :banner-with-icon="zone.bannerWithIcon"
      />
    </template>
    <template v-else-if="zone?.featureGrid">
      <FeatureGrid
        :feature-grid="zone.featureGrid"
      />
    </template>
    <template v-else-if="zone?.editorialCarousel">
      <EditorialCarousel
        :editorial-carousel="zone.editorialCarousel"
        :meta="meta"
      />
    </template>
    <template v-else-if="zone?.browseMediaAd">
      <BrowseMediaAd
        :browse-media-ad="zone.browseMediaAd"
      />
    </template>
    <template v-else-if="zone?.serviceBanner">
      <ServicesBanner
        :service-banner="zone.serviceBanner"
      />
    </template>
    <template v-else-if="zone?.htmlSnippet">
      <HtmlSnippet
        :html-snippet="zone.htmlSnippet"
      />
    </template>
    <template v-else-if="zone?.essentials">
      <Essentials
        :essentials="zone.essentials"
      />
    </template>
    <template v-else-if="zone?.promoSlideshow">
      <PromoSlideshow
        :promo-slideshow="zone.promoSlideshow"
        :meta="meta"
      />
    </template>
    <template v-else-if="zone?.brandIndex">
      <BrandIndex
        :brands="zone.brandIndex"
      />
    </template>
    <template v-else-if="zone?.flexPool">
      <FlexiblePool
        :flex-pool="zone.flexPool"
        :attributes="rowAttributes"
        :meta="meta"
      />
    </template>
    <template v-else-if="zone?.onScreenBanner">
      <OnScreenBanner
        :on-screen-banner="zone.onScreenBanner"
      />
    </template>
    <template v-else-if="zone?.messageInset">
      <MessageInset
        :message-inset="zone.messageInset"
      />
    </template>
    <template v-else-if="zone?.loyaltyStarReward">
      <LoyaltyStarReward
        :loyalty-star-reward="zone.loyaltyStarReward"
      />
    </template>
    <template v-else-if="(zone?.copyBlock && copyEnabled)">
      <SeoContent
        :seo-content="{copyBlock: [zone.copyBlock]}"
        :show-copy="copyEnabled"
      />
    </template>
    <template v-else-if="zone?.largeCarousel">
      <LargeCarousel
        :large-carousel="zone.largeCarousel"
        :meta="meta"
      />
    </template>
  </div>
</template>

<script setup>
import { ref, computed, defineAsyncComponent } from 'vue';

import ShortTextAd from './text/ShortTextAd';
import SingleImageTextAd from './text/SingleImageTextAd';
import SingleImageTextAdWrapper from './text/SingleImageTextAdWrapper';
import TextAd from './text/TextAd';
import ProductPool from './pool/ProductPool';
import ProsProductPool from './pool/ProsProductPool';
import PromoSlideshow from './promoSlideshow/PromoSlideshow';

const SalesBanner = defineAsyncComponent(() => import('./banner/SalesBanner'));
const BannerWithIcon = defineAsyncComponent(() => import('./bannerWithIcon/BannerWithIcon'));
const BrandShop = defineAsyncComponent(() => import('./brandShop/BrandShop'));
const BrandShopLogoBanner = defineAsyncComponent(() => import('./brandShopLogoBanner/BrandShopLogoBanner'));
const BrowseMediaAd = defineAsyncComponent(() => import('./browseMediaAd/BrowseMediaAd'));
const Carousel = defineAsyncComponent(() => import('./carousel/Carousel'));
const BrandCategoryIcons = defineAsyncComponent(() => import('./categoryIcons/BrandCategoryIcons'));
const VisualFilter = defineAsyncComponent(() => import('./categoryIcons/VisualFilter'));
const VisualNavigation = defineAsyncComponent(() => import('./categoryIcons/VisualNavigation'));
const EditorialCarousel = defineAsyncComponent(() => import('./editorialCarousel/EditorialCarousel'));
const Essentials = defineAsyncComponent(() => import('./essentials/Essentials'));
const FeatureGrid = defineAsyncComponent(() => import('./featureGrid/FeatureGrid'));
const Header = defineAsyncComponent(() => import('./header/Header'));
const HtmlSnippet = defineAsyncComponent(() => import('./htmlSnippet/HtmlSnippet'));
const IconGrid = defineAsyncComponent(() => import('./iconGrid/IconGrid'));
const ImageMap = defineAsyncComponent(() => import('./imageMap'));
const LoyaltyStarReward = defineAsyncComponent(() => import('./loyaltyStarReward'));
const MessageInset = defineAsyncComponent(() => import('./messageInset/MessageInset'));
const OnScreenBanner = defineAsyncComponent(() => import('./onScreenBanner'));
const Placeholder = defineAsyncComponent(() => import('./placeholder/Placeholder'));
const FlexiblePool = defineAsyncComponent(() => import('./pool/FlexiblePool'));
const SubAdPool = defineAsyncComponent(() => import('./pool/SubAdPool'));
const ServicesBanner = defineAsyncComponent(() => import('./servicesBanner/ServicesBanner'));
const BrandShowcaseMedia = defineAsyncComponent(() => import('./siteMonetization/BrandShowcaseMedia'));
const GoogleAdPlaceholderMedia = defineAsyncComponent(() => import('./siteMonetization/GoogleAdPlaceholderMedia'));
const SponsoredItemsMedia = defineAsyncComponent(() => import('./siteMonetization/SponsoredItemsMedia'));
const Spacer = defineAsyncComponent(() => import('./spacer'));
const HeroSubAd = defineAsyncComponent(() => import('./subAd/HeroSubAd'));
const SubAd = defineAsyncComponent(() => import('./subAd/SubAd'));
const SubAdFourImages = defineAsyncComponent(() => import('./subAd/SubAdFourImages'));
const SeoContent = defineAsyncComponent(() => import('./seoContent'));
const LargeCarousel = defineAsyncComponent(() => import('./largeCarousel/LargeCarousel'));
const BrandIndex = defineAsyncComponent(() => import('./BrandIndex'));

const props = defineProps({
  zones: {
    type: Array,
    default: () => ([]),
  },
  meta: {
    type: Object,
    default: () => {},
  },
  rowAttributes: {
    type: Object,
    default: () => ({}),
  },
  ksMeta: {
    type: Object,
    default: () => ({}),
  },
  isPlpPage: {
    type: String,
    default: null,
  },
});

const copyEnabled = ref(props.ksMeta?.properties?.aemContainerCopyBlockEnabled || false);
const getDataAttributesFromObj = (obj, attributeNamesArray) => {
  const dataAttributesObj = {};

  attributeNamesArray.forEach((attributeName) => {
    if (obj[attributeName]) {
      dataAttributesObj[`data-${attributeName.toLowerCase()}`] = obj[attributeName];
    }
  });

  return dataAttributesObj;
};

const adobeTargetId = computed(() => {
  const targetMediaTypes = new Set([
    'brandCategoryIcon',
    'imageMap',
    'promoSlideshow',
    'largeCarousel',
    'visualNavigation',
    'visualFilter',
    'serviceBanner',
    'essentials',
    'brandShop',
    'featureGrid',
    'onScreenBanner',
    'salesBanner',
    'brandShopLogoBanner',
    'BrowseMediaAd',
    'editorialCarousel',
    'htmlSnippet',
    'heroSubAd',
    'loyaltyStarReward',
    'shortTextAd',
    'singleImageTextAd',
    'carousel',
    'subAd',
    'subAdFourImages',
    'subAdPool',
    'textAd',
    'bannerWithIcon',
  ]);

  const targetMediaType = Object.keys(props.zones?.[0]).filter((item) => targetMediaTypes.has(item));

  const targetId = props.zones?.[0]?.[targetMediaType]?.attributes?.targetIdentifier;
  return targetId || '';
});

</script>

<style lang="scss" brand="mcom" scoped>
@import '../scss/globalAttributes.mcom.scss';
</style>

<style lang="scss" brand="bcom" scoped>
@import '../scss/globalAttributes.bcom.scss';
</style>
